import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { eliminaAudio } from '../../actions/audio';

const AudioElement = ({ auth: { user }, idAudio, titoloAudio, descrizioneAudio, codiceAudio, eliminaAudio, link }) => {
  const [caricato, setCaricato] = useState(false);

  return (
    <div className="call-item">
      <div className="call-item-wrap">
        <div>
          <h2 className="heading-2">{titoloAudio}</h2>
          <p className="heading-2">{descrizioneAudio}</p>
          {codiceAudio ? (
            caricato ? (
              <div className="iframe-audio" dangerouslySetInnerHTML={{ __html: codiceAudio }} />
            ) : (
              <button className="button w-button" onClick={() => setCaricato(true)}>
                ▶ Ascolta
              </button>
            )
          ) : null}
          {link ? (
            <div className="pulsante-link-audio"><a href={link} target="_blank" rel="noreferrer">apri</a></div>
          ) : null}
        </div>
      </div>
      {user && user.ruolo === 'admin' ? (
        <>
          <div className="modifica_audio">
            <a href={`modifica-audio/${idAudio}`} className="button w-button"><img src="/assets/media/pen-solid.svg" alt="Icona modifica" /></a>
          </div>
          <div className="elimina_audio">
            <a className="button w-button" onClick={() => eliminaAudio({ idAudio })}><img src="/assets/media/trash-alt-solid.svg" alt="Icona elimina" /></a>
          </div>
        </>
      ) : null}
    </div>
  );
};

AudioElement.propTypes = {
  auth: PropTypes.object.isRequired,
  eliminaAudio: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, { eliminaAudio })(AudioElement);
